import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Filter, useFilter } from "@/partner/shared/components/Filter";
import { useInstancePaymentProviders } from "@/partner/entities/instance";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  PaymentStatusType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";
import { buildPaymentsFilter } from "../model/buildPaymentsFilter";

// Статусы платежа: подписи уже есть в сиде (`payments.status.*`), значение
// опции — само enum-значение схемы, оно и уходит в `filter.status`.
const STATUS_OPTIONS: { value: PaymentStatusType; labelKey: string }[] = [
  { value: PaymentStatusType.PendingType, labelKey: "payments.status.pending" },
  {
    value: PaymentStatusType.SucceededType,
    labelKey: "payments.status.succeeded",
  },
  {
    value: PaymentStatusType.CanceledType,
    labelKey: "payments.status.canceled",
  },
  {
    value: PaymentStatusType.RefundedType,
    labelKey: "payments.status.refunded",
  },
];

export const PaymentsFilter: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  // Селект «Провайдер» предлагает только провайдеров развёртывания:
  // платежей остальных на инстансе не бывает.
  const paymentProviders = useInstancePaymentProviders();

  return (
    <Filter
      title={t("payments.pageTitle")}
      paymentProviders={paymentProviders}
      action={
        <DownloadReportButton
          type={ReportTypeType.PaymentsType}
          filter={
            buildPaymentsFilter(filter) as Record<string, unknown> | undefined
          }
        />
      }
      selects={[
        {
          name: "status",
          label: t("payments.filter.statusLabel"),
          options: STATUS_OPTIONS.map(({ value, labelKey }) => ({
            value,
            label: t(labelKey),
          })),
        },
      ]}
      fields={{
        search: true,
        dateFrom: true,
        dateTo: true,
        productIds: true,
        providers: true,
        currency: true,
      }}
    />
  );
};
